export default "__VITE_ASSET__BPr0Mbub__"